"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDefaultLineItemDescription = exports.createDefaultQuoteSectionDisplayData = exports.ReservedFieldIds = void 0;
var ReservedFieldIds;
(function (ReservedFieldIds) {
    ReservedFieldIds["Description"] = "description";
    ReservedFieldIds["Price"] = "price";
    ReservedFieldIds["Quantity"] = "quantity";
    ReservedFieldIds["Item"] = "item";
})(ReservedFieldIds || (exports.ReservedFieldIds = ReservedFieldIds = {}));
var createDefaultQuoteSectionDisplayData = function () {
    return {
        collapsed: false,
        showSubtotal: true,
    };
};
exports.createDefaultQuoteSectionDisplayData = createDefaultQuoteSectionDisplayData;
var createDefaultLineItemDescription = function () {
    return {
        label: "Description",
        id: ReservedFieldIds.Description,
        visible: true,
    };
};
exports.createDefaultLineItemDescription = createDefaultLineItemDescription;
